import { ColorSample } from '@component/ColorSample';
import * as S from '../../../../Style';
import { Race } from '@types';

const RegisterInfoModule = ({
  idx,
  module,
  handleChange,
}: {
  idx: number;
  module: Race.RaceRegisterInfoDescriptionModule;
  handleChange: any;
}) => {
  return (
    <>
      <h4>신청정보 모듈 (선착순, 신청인원, 모집마감기한 등)</h4>
      <S.RowContainer>
        <S.RowFormField>
          <label>배경색</label>
          <input
            value={module.bgColor}
            onChange={(e) => handleChange(idx, 'bgColor', e.target.value)}
          />
          <ColorSample color={module.bgColor} />
        </S.RowFormField>
        <S.RowFormField>
          <label>글씨색</label>
          <input
            value={module.textColor}
            onChange={(e) => handleChange(idx, 'textColor', e.target.value)}
          />
          <ColorSample color={module.textColor} />
        </S.RowFormField>
      </S.RowContainer>
    </>
  );
};

export default RegisterInfoModule;
